import React, { HTMLProps } from 'react';
import classNames from 'classnames';

type PropsType = HTMLProps<HTMLDivElement>;

import styles from './ProductCardOverlay.module.scss';

export default function ProductCardOverlay({
  children,
  className,
}: PropsType): JSX.Element {
  return (
    <div className={classNames(styles.container, className)}>{children}</div>
  );
}
